import { useQuery } from '@tanstack/react-query';
import { getProduct } from '../../services/products';

function useProduct(productId: string | null | undefined) {
  return useQuery({
    queryKey: ['product', productId],
    queryFn: () => getProduct(productId!),
    enabled: !!productId,
    staleTime: 0,
  });
}

export default useProduct;
